import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    BuildingClient,
    BuildingContactViewPaginatedResultDto,
    BuildingMapResult,
    BuildingView,
    BuildingViewPaginatedResultDto,
    CompanyBuildingViewPaginatedResultDto,
    CompanyView,
    QuickSearchBuildingParameters,
    SearchAvailableBuildingCompaniesParameters,
    SearchBuildingsForAccountParameters,
    SearchBuildingsForCompanyParameters,
    SearchBuildingsForContactParameters,
    SearchBuildingsMapParameters,
    SearchBuildingsParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class BuildingService {
    constructor(private readonly client: BuildingClient) {}

    async getById(id: number): Promise<BuildingView> {
        return await lastValueFrom(this.client.buildingGetById(id));
    }

    async save(body: BuildingView): Promise<BuildingView> {
        return await lastValueFrom(this.client.buildingSave(body));
    }

    async searchBuilding(body: SearchBuildingsParameters | undefined): Promise<BuildingViewPaginatedResultDto> {
        return await lastValueFrom(this.client.buildingSearch(body));
    }

    async searchBuildingsForCompany(
        body: SearchBuildingsForCompanyParameters | undefined
    ): Promise<CompanyBuildingViewPaginatedResultDto> {
        return await lastValueFrom(this.client.buildingSearchForCompany(body));
    }

    async searchBuildingsForAccount(
        body: SearchBuildingsForAccountParameters | undefined
    ): Promise<CompanyBuildingViewPaginatedResultDto> {
        return await lastValueFrom(this.client.buildingSearchForAccount(body));
    }

    async searchBuildingsForContact(
        body: SearchBuildingsForContactParameters | undefined
    ): Promise<BuildingContactViewPaginatedResultDto> {
        return await lastValueFrom(this.client.buildingSearchForContact(body));
    }

    async searchAvailableCompanies(body: SearchAvailableBuildingCompaniesParameters): Promise<CompanyView[]> {
        return await lastValueFrom(this.client.buildingSearchAvailableCompanies(body));
    }

    async searchMap(body: SearchBuildingsMapParameters): Promise<BuildingMapResult[]> {
        return await lastValueFrom(this.client.buildingMapSearch(body));
    }

    async search(body: QuickSearchBuildingParameters): Promise<BuildingView[]> {
        return await lastValueFrom(this.client.buildingQuickSearch(body));
    }

    async activate(id: number): Promise<void> {
        return await lastValueFrom(this.client.buildingActivate(id));
    }

    async deactivate(id: number): Promise<void> {
        return await lastValueFrom(this.client.buildingDeactivate(id));
    }
}
